import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-16634 — who works a form's submissions without holding View all form submissions:
 * one row per role or per person. Exactly one of the two is set on a row.
 *
 * A form with no rows is seen only by View all holders (Admin) and by whoever a submission
 * is assigned to; no form gets a default list (owner, 2026-09-28). Roles are matched as
 * assigned, as a notify action's recipients are: a child role is its own entry.
 *
 * `fk_user__id` is the TENANT user id (`user._id`), the same identity recipients use.
 */
@Index('idx_form_access_form', ['fkFormId'], {})
@Index('idx_form_access_role', ['fkRbacRoleId'], {})
@Index('idx_form_access_user', ['fkUserId'], {})
@Entity('form_access')
export class FormAccessEntity extends BaseEntity {
	@Column('int', { name: 'fk_form__id', unsigned: true })
	public fkFormId!: number;

	@Column('int', { name: 'fk_rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;

	@Column('int', { name: 'fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;
}
